// extracted by mini-css-extract-plugin
export default {"project":"Project_project__QdVrB","left_column":"Project_left_column__WSgyZ","right_column":"Project_right_column__5gjEO","tags":"Project_tags__XFjpB","texts":"Project_texts__YVQDc"};